/**
 * Ячейка тира (§2.3 «Бейдж тира», §4.3, §5.2).
 *
 * Отличается от прочих справочников только показом: значение — бейдж
 * `TierBadge`, пустое — пунктирная рамка с «—» (пустой тир выглядит как
 * незаполненное поле, а не как «тира нет по смыслу»). Редактор тот же —
 * поповер справочника, и в строке категории он правит тир привязки.
 */
import { TierBadge } from '../../../../components/index.js'
import { EnumCell } from './EnumCell.js'
import type { CellProps } from './CellBox.js'

export function TierCell(props: CellProps) {
  if (props.editing && !props.readOnly) return <EnumCell {...props} />
  const value = typeof props.cell.value === 'string' ? props.cell.value : null
  return (
    <span className="cell__value">
      <TierBadge tier={value} />
    </span>
  )
}
